import { Slide } from '@mui/material';
import { Box, FrontTable } from 'src/ui-components';

import { useTableData } from '../hooks/useTableData';

export const TableView = () => {
  const data = useTableData();

  return (
    <Slide in direction="down">
      <Box>
        <FrontTable {...data} />
      </Box>
    </Slide>
  );
};
